
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ReportsSubscriptionType enum
 */
class ReportsSubscriptionType {
  /**
   * Initialize enum with a given value
   * @param {ReportsSubscriptionType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ReportsSubscriptionType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ReportsSubscriptionType}
   * @param {!ReportsSubscriptionType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ReportsSubscriptionType)) {
      throw new TypeError('Instance of ReportsSubscriptionType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ReportsSubscriptionType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ReportsSubscriptionType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ReportsSubscriptionType.NONE.value) {
      return 'NONE'
    }
    if (this.value === ReportsSubscriptionType.DAILY_CONFIRMATIONS_ONLY.value) {
      return 'DAILY_CONFIRMATIONS_ONLY'
    }
    if (this.value === ReportsSubscriptionType.MONTHLY_STATEMENTS_ONLY.value) {
      return 'MONTHLY_STATEMENTS_ONLY'
    }
    if (this.value === ReportsSubscriptionType.ALL.value) {
      return 'ALL'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ReportsSubscriptionType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ReportsSubscriptionType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ReportsSubscriptionType} Created enum
   */
  static fromObject (other) {
    return new ReportsSubscriptionType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ReportsSubscriptionType.NONE = new ReportsSubscriptionType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
ReportsSubscriptionType.DAILY_CONFIRMATIONS_ONLY = new ReportsSubscriptionType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
ReportsSubscriptionType.MONTHLY_STATEMENTS_ONLY = new ReportsSubscriptionType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
ReportsSubscriptionType.ALL = new ReportsSubscriptionType(0 + 3)

export { ReportsSubscriptionType };

/**
 * Fast Binary Encoding ReportsSubscriptionType field model
 */
class FieldModelReportsSubscriptionType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelReportsSubscriptionType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelReportsSubscriptionType}
   * @param {ReportsSubscriptionType=} defaults Default value, defaults is new ReportsSubscriptionType()
   * @returns {!ReportsSubscriptionType} Result value
   */
  get (defaults = new ReportsSubscriptionType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ReportsSubscriptionType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelReportsSubscriptionType}
   * @param {!ReportsSubscriptionType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelReportsSubscriptionType };
